/* City Beauty Footer - Shopify Compatible JavaScript */

// Footer Form Validation and Submission
function validateCheckBox(submitClicked = false) {
    var submitBtn = document.getElementById("contactSubmit");
    var emailInput = document.getElementById('k_id_email');
    var firstnameInput = document.getElementById('k_id_firstname');

    if (emailInput && firstnameInput && submitBtn) {
        if (emailInput.value.length > 0 && firstnameInput.value.length > 0) {
            if (validateEmail(emailInput.value)) {
                submitBtn.classList.remove('disable');
                var invalidCheck = document.getElementById("invalid-check");
                if (invalidCheck) {
                    invalidCheck.style.color = "#E1C17A";
                    if(submitClicked) {
                        invalidCheck.innerHTML = "Thanks for signing up! Get ready for exclusive sales and insider info sent straight to your inbox!";
                    }
                    else {
                        invalidCheck.innerHTML = "";
                    }
                }
            } else {
                submitBtn.classList.add('disable');
                var invalidCheck = document.getElementById("invalid-check");
                if (invalidCheck) {
                    invalidCheck.style.color = "#C94C4C";
                }
            }
        } else {
            submitBtn.classList.add('disable');
            var invalidCheck = document.getElementById("invalid-check");
            if (invalidCheck) {
                invalidCheck.style.color = "#C94C4C";
            }
        }
    }
}

// Email validation
const validateEmail = (email) => {
    let regexEmail = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
    return String(email).toLowerCase().match(regexEmail) ? true : false;
};

// Phone validation
const validatePhone = (phone) => {
    let regexPhone = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return String(phone).match(regexPhone) ? true : false;
};

// Cookie utility functions
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=" + domain + ";path=/";
}

// Back to top functionality
function initBackToTop() {
    const goToTopBtn = document.getElementById('goToTop');
    if (goToTopBtn) {
        // Show/hide button based on scroll position
        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 100) {
                goToTopBtn.style.display = 'flex';
            } else {
                goToTopBtn.style.display = 'none';
            }
        });

        // Smooth scroll to top when clicked
        goToTopBtn.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            return false;
        });
    }
}

// Mobile accordion functionality
function initMobileAccordions() {
    const accordions = document.querySelectorAll('.details-accordion');
    
    accordions.forEach(function(accordion, index) {
        const toggle = accordion.querySelector('.detail-collapse');
        const content = accordion.querySelector('.detail-collapse-content');
        const chevron = accordion.querySelector('.accordion-chevron');
        
        if (toggle && content) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Close other accordions
                accordions.forEach(function(otherAccordion, otherIndex) {
                    if (otherIndex !== index) {
                        const otherContent = otherAccordion.querySelector('.detail-collapse-content');
                        const otherToggle = otherAccordion.querySelector('.detail-collapse');
                        const otherChevron = otherAccordion.querySelector('.accordion-chevron');
                        
                        if (otherContent) {
                            otherContent.classList.remove('show');
                        }
                        if (otherToggle) {
                            otherToggle.setAttribute('aria-expanded', 'false');
                        }
                        if (otherChevron) {
                            otherChevron.classList.remove('fa-chevron-up');
                            otherChevron.classList.add('fa-chevron-down');
                        }
                    }
                });
                
                // Toggle current accordion
                const isExpanded = content.classList.contains('show');
                
                if (!isExpanded) {
                    content.classList.add('show');
                }
                else {
                    content.classList.remove('show');
                }
                
                // Update aria-expanded attribute
                toggle.setAttribute('aria-expanded', !isExpanded);
                
                // Toggle chevron icon
                if (chevron) {
                    if (!isExpanded) {
                        chevron.classList.remove('fa-chevron-down');
                        chevron.classList.add('fa-chevron-up');
                    }
                    else {
                        chevron.classList.remove('fa-chevron-up');
                        chevron.classList.add('fa-chevron-down');
                    }
                }
            });
        }
    });
}

// Initialize Klaviyo tracking
function initKlaviyo() {
    // Check for existing Klaviyo script
    if (typeof window.klaviyo === 'undefined') {
        window._klOnsite = window._klOnsite || [];
        try {
            window.klaviyo = new Proxy({}, {
                get: function(n, i) {
                    return "push" === i ? function() {
                        var n;
                        (n = window._klOnsite).push.apply(n, arguments);
                    } : function() {
                        for (var n = arguments.length, o = new Array(n), w = 0; w < n; w++) o[w] = arguments[w];
                        var t = "function" == typeof o[o.length-1] ? o.pop() : void 0, e = new Promise((function(n) {
                            window._klOnsite.push([i].concat(o, [function(i) {
                                t && t(i), n(i);
                            }]));
                        }));
                        return e;
                    };
                }
            });
        } catch(n) {
            window.klaviyo = window.klaviyo || [];
            window.klaviyo.push = function() {
                var n;
                (n = window._klOnsite).push.apply(n, arguments);
            };
        }
    }

    // Identify user if auth data exists
    var re = new RegExp("ghm_auth_data" + "=([^;]+)");
    var value = re.exec(document.cookie);
    if (value != null && window.klaviyo) {
        var trackingDetails = JSON.parse(unescape(value[1]));
        window.klaviyo.push(['identify', {
            '$email': trackingDetails.email,
            '$first_name': trackingDetails.firstName
        }]);
    }
}

// Initialize BBB (Better Business Bureau) script
function initBBB() {
    var bbbprotocol = (("https:" == document.location.protocol) ? "https://" : "http://");
    if (!document.querySelector('script[src*="seal-sanjose.bbb.org"]')) {
        (function() {
            var s = document.createElement('script');
            //s.src = bbbprotocol + 'seal-sanjose.bbb.org' + decodeURIComponent('%2Flogo%2Fcity-beauty-718336.js');
            s.src = 'https://seal-sanjose.bbb.org/logo/city-beauty-718336.js';
            s.type = 'text/javascript';
            s.async = true;
            var st = document.getElementsByTagName('script');
            if (st && st.length > 0) {
                st = st[st.length-1];
                var pt = st.parentNode;
                if (pt) {
                    var nextSibling = st.nextSibling;
                    if (nextSibling && nextSibling.parentNode === pt) {
                        pt.insertBefore(s, nextSibling);
                        console.log('BBB script inserted 1');
                    }
                    else {
                        pt.appendChild(s);
                        console.log('BBB script inserted 2');
                    }
                }
                else {
                    console.log('BBB script not inserted');
                }
            }
            else {
                console.log('BBB script not inserted');
            }
        })();
    }
}

// Font Awesome fallback
function initFontAwesomeFallback() {
    // Skip Font Awesome fallback to prevent 404 errors
    // Font Awesome icons are already defined in CSS
    return;
}

// Bootstrap fallback
function initBootstrapFallback() {
    // Skip Bootstrap fallback to prevent 404 errors
    // Bootstrap functionality is handled by existing CSS
    return;
}

// Owl Carousel fallback
function initOwlCarouselFallback() {
    // Skip Owl Carousel fallback to prevent 404 errors
    // Carousel functionality is not used in footer
    return;
}

// Raty fallback
function initRatyFallback() {
    // Skip Raty fallback to prevent 404 errors
    // Rating functionality is not used in footer
    return;
}

// Initialize all footer functionality
function initFooter() {
    // Initialize core functionality
    initBackToTop();
    initMobileAccordions();
    initKlaviyo();
    initBBB();
    
    // Initialize fallbacks
    initFontAwesomeFallback();
    initBootstrapFallback();
    initOwlCarouselFallback();
    initRatyFallback();
    
    // Set current path cookie for branded site redirects
    const currentPath = window.location.pathname + window.location.search;
    setCookie('brandedSiteRedirectPath', currentPath, 1);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter);
} else {
    initFooter();
}

// Export functions for external use
window.CityBeautyFooter = {
    validateCheckBox: validateCheckBox,
    validateEmail: validateEmail,
    validatePhone: validatePhone,
    getCookie: getCookie,
    setCookie: setCookie,
    initFooter: initFooter
};
